import Image from 'next/image'
import React from 'react'
import styles from 'src/components/explorer/Transaction.module.scss'
import { AlgorandLogo } from 'src/assets/images'
import Head from 'next/head'
const ExplorerLayout = ({ children }) => {
  return (
    <>
      <Head>
        <link rel='shortcut icon' href='https://algoexplorer.io/icons/favicon.ico' />
        <meta name='viewport' content='initial-scale=1.0, width=device-width' />
        <meta name='robots' content='noindex' />
      </Head>
      <div className={styles['transactions-page-content']}>
        <div className='header-algorand'>
          <Image src={AlgorandLogo} width={220}  alt='algorand-logo'
          />
        </div>
        {children}
      </div>
    </>
  )
}

export default ExplorerLayout
